import { Stack, Typography } from '@optimus-web/core';
import { LocalizedProperty, lt } from '@mews/framework';
import { useCurrentRateGroupContext } from '../../../../../contexts';

interface Props {
    rateIds?: string[] | null;
}

export const PolicyExceptionRatesCell = ({ rateIds }: Props) => {
    const { rates, names } = useCurrentRateGroupContext();

    return (
        <Stack vertical>
            {rateIds ? (
                rates?.map((rate) =>
                    rateIds.includes(rate.id) ? (
                        <Typography key={rate.id} textStyle="bodyMedium" whiteSpace="nowrap" as="div">
                            {rate.name}
                        </Typography>
                    ) : null
                )
            ) : (
                <>
                    <Typography textStyle="bodyMediumStrong" whiteSpace="nowrap" as="div">
                        <LocalizedProperty property={names} />
                    </Typography>
                    <Typography textStyle="bodyMedium" variant="secondary" whiteSpace="nowrap" as="div">
                        {lt('RateGroup')}
                    </Typography>
                </>
            )}
        </Stack>
    );
};
